"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLayerImpl = exports.useExperimentImpl = exports.useConfigImpl = exports.useGateImpl = void 0;
var react_1 = require("react");
var statsig_js_1 = require("statsig-js");
var StatsigContext_1 = __importDefault(require("./StatsigContext"));
var Statsig_1 = __importDefault(require("./Statsig"));
function useGateImpl(gateName, options, exposureLoggingDisabled) {
    if (exposureLoggingDisabled === void 0) { exposureLoggingDisabled = false; }
    var _a = (0, react_1.useContext)(StatsigContext_1.default), initialized = _a.initialized, userVersion = _a.userVersion, initStarted = _a.initStarted;
    var gate = (0, react_1.useMemo)(function () {
        return initStarted
            ? exposureLoggingDisabled
                ? Statsig_1.default.checkGateWithExposureLoggingDisabled(gateName, options)
                : Statsig_1.default.checkGate(gateName, options === null || options === void 0 ? void 0 : options.ignoreOverrides)
            : false;
    }, [
        initialized,
        initStarted,
        gateName,
        userVersion,
        options,
        exposureLoggingDisabled,
    ]);
    return {
        isLoading: !initialized,
        value: gate,
    };
}
exports.useGateImpl = useGateImpl;
function useConfigImpl(configName, options, exposureLoggingDisabled) {
    if (exposureLoggingDisabled === void 0) { exposureLoggingDisabled = false; }
    var _a = (0, react_1.useContext)(StatsigContext_1.default), initialized = _a.initialized, initStarted = _a.initStarted, userVersion = _a.userVersion;
    var config = (0, react_1.useMemo)(function () {
        return initStarted
            ? exposureLoggingDisabled
                ? Statsig_1.default.getConfigWithExposureLoggingDisabled(configName, options)
                : Statsig_1.default.getConfig(configName, options === null || options === void 0 ? void 0 : options.ignoreOverrides)
            : new statsig_js_1.DynamicConfig(configName, {}, '', {
                time: Date.now(),
                reason: statsig_js_1.EvaluationReason.Uninitialized,
            });
    }, [
        initialized,
        initStarted,
        configName,
        userVersion,
        options,
        exposureLoggingDisabled,
    ]);
    return {
        isLoading: !initialized,
        config: config,
    };
}
exports.useConfigImpl = useConfigImpl;
function useExperimentImpl(experimentName, options, exposureLoggingDisabled) {
    if (exposureLoggingDisabled === void 0) { exposureLoggingDisabled = false; }
    var _a = (0, react_1.useContext)(StatsigContext_1.default), initialized = _a.initialized, initStarted = _a.initStarted, userVersion = _a.userVersion;
    var config = (0, react_1.useMemo)(function () {
        return initStarted
            ? exposureLoggingDisabled
                ? Statsig_1.default.getExperimentWithExposureLoggingDisabled(experimentName, options)
                : Statsig_1.default.getExperiment(experimentName, options === null || options === void 0 ? void 0 : options.keepDeviceValue, options === null || options === void 0 ? void 0 : options.ignoreOverrides)
            : new statsig_js_1.DynamicConfig(experimentName, {}, '', {
                time: Date.now(),
                reason: statsig_js_1.EvaluationReason.Uninitialized,
            });
    }, [
        initialized,
        initStarted,
        experimentName,
        userVersion,
        options,
        exposureLoggingDisabled,
    ]);
    return {
        isLoading: !initialized,
        config: config,
    };
}
exports.useExperimentImpl = useExperimentImpl;
function useLayerImpl(layerName, options, exposureLoggingDisabled) {
    if (exposureLoggingDisabled === void 0) { exposureLoggingDisabled = false; }
    var _a = (0, react_1.useContext)(StatsigContext_1.default), initialized = _a.initialized, initStarted = _a.initStarted, userVersion = _a.userVersion;
    var layer = (0, react_1.useMemo)(function () {
        return initStarted
            ? exposureLoggingDisabled
                ? Statsig_1.default.getLayerWithExposureLoggingDisabled(layerName, options)
                : Statsig_1.default.getLayer(layerName, options === null || options === void 0 ? void 0 : options.keepDeviceValue)
            : statsig_js_1.Layer._create(layerName, {}, '', {
                time: Date.now(),
                reason: statsig_js_1.EvaluationReason.Uninitialized,
            });
    }, [
        initialized,
        initStarted,
        layerName,
        userVersion,
        options,
        exposureLoggingDisabled,
    ]);
    return {
        isLoading: !initialized,
        layer: layer,
    };
}
exports.useLayerImpl = useLayerImpl;
